exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._-_-src-components-componentKit2-___spinner__spinner___1xNXq{animation:_-_-src-components-componentKit2-___spinner__rotate___21DYY 2s linear infinite;z-index:2;position:absolute;top:50%;left:50%;margin:-25px 0 0 -25px;height:50px;stroke:#1d89e4;width:30px}._-_-src-components-componentKit2-___spinner__spinner___1xNXq ._-_-src-components-componentKit2-___spinner__path___RzjcB{stroke:hsl(210,70,75);stroke-linecap:round;animation:_-_-src-components-componentKit2-___spinner__dash___2UvI2 1.5s ease-in-out infinite}@keyframes _-_-src-components-componentKit2-___spinner__rotate___21DYY{to{transform:rotate(1turn)}}@keyframes _-_-src-components-componentKit2-___spinner__dash___2UvI2{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}", ""]);

// exports
exports.locals = {
	"spinner": "_-_-src-components-componentKit2-___spinner__spinner___1xNXq",
	"rotate": "_-_-src-components-componentKit2-___spinner__rotate___21DYY",
	"path": "_-_-src-components-componentKit2-___spinner__path___RzjcB",
	"dash": "_-_-src-components-componentKit2-___spinner__dash___2UvI2"
};


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!/var/www/build-health-2/~/postcss-loader!/var/www/build-health-2/src/components/componentKit2/spinner.css
// module id = 1385
// module chunks = 0